import { render, staticRenderFns } from "./TongHopDtLnTlCtBaoCaoGanDay.vue?vue&type=template&id=32ba9770&scoped=true"
import script from "./TongHopDtLnTlCtBaoCaoGanDay.vue?vue&type=script&lang=ts"
export * from "./TongHopDtLnTlCtBaoCaoGanDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba9770",
  null
  
)

export default component.exports